import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { Config } from 'src/infrastructure/config';
import { UserDTO } from 'src/models/DTO/user/user';
import { ContactRequestModel } from 'src/models/requestModels/contact/contactRequestModel';
import { ContactService } from 'src/services/request/contact/contact.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

@Component({
  selector: 'app-orderinvoiceaddress',
  templateUrl: './orderinvoiceaddress.component.html',
  styleUrls: ['./orderinvoiceaddress.component.css']
})
export class OrderinvoiceaddressComponent extends BaseComponent implements OnInit {

  public readonly modes = {
    user: 'user',
    company: 'company'
  }
  private _mode = this.modes.user;
  private _invoiceInfo: FormGroup;
  private _compInvoiceInfo: FormGroup;
  private _loggedUser?: UserDTO;

  constructor(
    private FB: FormBuilder,
    private contactsService: ContactService,
    private loggedUserService: LoggedUserService,
    private router: Router
  ) { 
    super();
    this.loggedUserService.userInfo$.subscribe((user) => {
      this._loggedUser = user;
    });
    this._invoiceInfo = FB.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      city: ['', [Validators.required]],
      residence: ['', [Validators.required]],
      address: ['', [Validators.required]],
    })

    this._compInvoiceInfo = FB.group({
      comp_name: ['', [Validators.required]],
      eic: ['', [Validators.required]],
      mol: ['', [Validators.required]],
      city: ['', [Validators.required]],
      address: ['', [Validators.required]],
      postalcode: ['', [Validators.required]],
      vat: [false, [Validators.required]],
      vatnumber: ['', [Validators.required]],
    })
  }

  ngOnInit(): void {
  }

  selectMode(mode: string) {
    this._mode = mode;
  }

  get mode() {
    return this._mode;
  }

  get invoiceInfo() {
    return this._invoiceInfo;
  }

  get compInvoiceInfo() {
    return this._compInvoiceInfo;
  }

  get doesCompanyHasVat() {
    return this._compInvoiceInfo.get('vat')?.value;
  }

  createAddress() {
    if (this._mode == this.modes.user) {
      const contactRequestModel: ContactRequestModel = {
        country_uuid: 'fee09419-17d4-4ec0-bf7d-a3b12b5a5cc9',
        contactable_type: Config.user,
        contactable_uuid: this._loggedUser!.data.uuid,
        type: Config.invoiceUserLocationRole,
        city: this._invoiceInfo.get('city')?.value,
        contact_person_first_name: this._invoiceInfo.get('first_name')?.value,
        contact_person_last_name: this._invoiceInfo.get('last_name')?.value,
        postcode: '0',
        street_number: 0,
        address_line_1: this._invoiceInfo.get('residence')?.value + ' ' + this._invoiceInfo.get('address')?.value,
        mobile_phone_1: this._invoiceInfo.get('phone')?.value,
        street_name: '0',
        mobile_phone_1_country_code:  'BG'
      }
      this.contactsService.registerUserContact(contactRequestModel).subscribe(() => {
        this.router.navigate(['order/adderess/select/INVOICE']);
      })
    }

    if (this._mode == this.modes.company) {
      let contactRequestModel: ContactRequestModel = {
        contactable_type: Config.user,
        contactable_uuid: this._loggedUser!.data.uuid,
        type: Config.userLocationRole,
        city: this._compInvoiceInfo.get('city')?.value,
        company_name: this._compInvoiceInfo.get('comp_name')?.value,
        company_number: this._compInvoiceInfo.get('eic')?.value,
        postcode: this._compInvoiceInfo.get('postalcode')?.value,
        address_line_1: this._compInvoiceInfo.get('residence')?.value + ' ' + this._compInvoiceInfo.get('address')?.value,
        mobile_phone_1: this._compInvoiceInfo.get('phone')?.value,
        // company_vat_number: this._compInvoiceInfo.get('')?.value,
        company_owner: this._compInvoiceInfo.get('mol')?.value,
        street_name: '0',
        street_number: 0,
        mobile_phone_1_country_code:  'BG'

        
      }
      if (this.doesCompanyHasVat) {
        contactRequestModel.company_vat_number = this._compInvoiceInfo.get('vatnumber')?.value
      }
      this.contactsService.registerUserContact(contactRequestModel).subscribe(() => {
        this.router.navigate(['order/adderess/select/INVOICE']);
      })
    }
  }
}
